import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 110 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M38.901.15c-.486 0-.88.39-.88.87v14.718c0 4.7-3.87 8.522-8.625 8.522-4.756 0-8.625-3.823-8.625-8.522v-5.326C20.771 4.754 16.112.15 10.385.15S0 4.754 0 10.41v14.72c0 .48.394.869.88.869s.88-.39.88-.87V10.412c0-4.699 3.87-8.522 8.625-8.522 4.756 0 8.626 3.823 8.626 8.522v5.326C19.01 21.397 23.669 26 29.396 26s10.386-4.603 10.386-10.262V1.021a.875.875 0 0 0-.88-.87m70.323 24.394L95.166.435a.88.88 0 0 0-.76-.435.88.88 0 0 0-.762.435L80.345 23.24 67.046.435a.883.883 0 0 0-1.2-.318.865.865 0 0 0-.32 1.188l14.059 24.11a.88.88 0 0 0 1.521 0l13.3-22.805 13.298 22.805a.88.88 0 0 0 1.2.318.865.865 0 0 0 .321-1.188M54.833.15c-7.177 0-13.016 5.799-13.016 12.925S47.656 26 54.833 26c4.967 0 9.57-2.872 11.729-7.316a.867.867 0 0 0-.409-1.162.877.877 0 0 0-1.169.406c-1.868 3.847-5.853 6.332-10.151 6.332-6.211 0-11.264-5.018-11.264-11.185S48.622 1.89 54.833 1.89c5.916 0 10.78 4.553 11.23 10.316H49.504a.873.873 0 0 0-.876.87c0 .48.392.87.876.87h17.467c.483 0 .876-.39.876-.87C67.848 5.948 62.009.15 54.833.15",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }